module.exports = __webpack_public_path__ + "texas-small.816a77f7.png";